<ng-container *ngIf="multiple; else single">
  <ng-container *ngIf="multicolumn; else singleColumnMultiSelect">
    <div class="filter-select-container">
      <button
        class="filter-select filter-select--multicolumn"
        data-test="select-multicolumn"
        [ngClass]="[
          control.value?.length ? 'multiple-selections' : '',
          (control.touched | isControlInvalidAndTouched:control.invalid) ? 'invalid' : '',
          formControlClassName
        ]"
        (mousedown)="expandClickMultiSelectMenu($event)"
        (keydown)="handleMultiSelectKeyDown($event)"
        (keyup.escape)="escapeMenu($event)"
        (blur)="onBlur($event)"
        [attr.aria-describedby]="formControlName
          && (control.touched | isControlInvalidAndTouched:control.invalid)
            ? formControlName + '-error-messages' : null"
        [attr.aria-expanded]="isExpanded"
        [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
        [attr.required]="(control | isControlRequired) || null"
        [attr.aria-label]="placeholder + ': ' + control.value.length + ' selections'"
        aria-haspopup="listbox"
        [disabled]="control.disabled"
        tabindex="0"
        #select
      >
        <div class="filter-select-inner-container">
          <span
            *ngIf="placeholder && currentSelections.length !== 1"
            class="placeholder-text"
          >
            {{ placeholder }}
          </span>
          <span class="highlighted-single-option" *ngIf="currentSelections.length === 1">
            {{ currentSelections[0].name }}
          </span>
          <span *ngIf="currentSelections.length > 1" class="filter-select-overflow-count">
            {{ currentSelections.length }}
          </span>
          <iris-icon
            *ngIf="!currentSelections.length"
            name="expand_more"
            class="filter-select-toggle"
            [size]="iconSizes.MD"
            [usage]="iconUsageTypes.DECORATIVE"
            [color]="iconColors.BRAND1"
          ></iris-icon>
          <iris-icon
            *ngIf="currentSelections.length && !isRequired"
            (mousedown)="expandClickMultiSelectMenu($event)"
            class="clear-value-icon filter-select-toggle"
            name="close"
            [size]="iconSizes.SM"
            [usage]="iconUsageTypes.DECORATIVE"
            [attr.data-test]="'clear-value-' + placeholder"
          ></iris-icon>
        </div>
      </button>

      <div
        [ngClass]="{'hidden': !isExpanded, 'drop-up': shouldDropUp, 'expanded': showAll}"
        class="select-multicolumn-listbox-wrapper"
      >
        <h3 class="listbox-header">
          {{ placeholder }}
        </h3>
        <div
          class="filter-select-listbox multicolumn-listbox"
          data-test="multicolumn-listbox"
          role="listbox"
          #listbox
        >
          <ng-container *ngFor="let category of categorizedOptions; let categoryIndex = index">
            <h4
              *ngIf="category.name && categorizedOptions.length > 1"
              class="category-label"
              [id]="category.name | joinWithHyphens"
            >
              {{ category.name }}
            </h4>
            <ul
              *ngIf="category.options.length > 0"
              class="category-list-options"
              [ngClass]="{'specialties': category.name === 'Specialties', 'expanded': showAll}"
              [attr.aria-labelledby]="category.name | joinWithHyphens"
              [attr.aria-multiselectable]="true"
            >
              <ng-container *ngFor="let option of category.options; let i = index">
                <li
                  *ngIf="showAll || !category.trimmedListCount || i < category.trimmedListCount"
                  class="filter-select-list-item multicolumn-list-item"
                  [ngClass]="{'selected': option.value && (control.value | isOptionInSelections:option.value:compareOptions)}"
                  [id]="formControlName + '-dropdown-option' + i"
                  [attr.data-test]="'filter-select-list-item-' + option.name"
                  (mousedown)="$event.preventDefault()"
                  (click)="changeMultiSelection(option)"
                  (keydown)="handleMultiSelectKeyDown($event)"
                  (keyup.escape)="escapeMenu($event)"
                  (blur)="onBlur($event)"
                  (mouseenter)="onHoverEnter(option.value)"
                  (mouseleave)="onHoverLeave()"
                  [attr.aria-selected]="control.value | isOptionInSelections:option.value:compareOptions"
                  [attr.aria-label]="category.name + ': ' + option.name"
                  role="option"
                  tabindex="-1"
                >
                  <div class="iris-checkbox" (blur)="onBlur($event)">
                    <div
                      class="iris-checkbox-highlight-circle"
                      [ngClass]="{'show-highlight': currentFocusedValue === option.value || currentHoveredValue === option.value}"
                    ></div>
                    <div
                      class="iris-checkbox-box"
                      [ngClass]="{
                        'is-checked': option.value && (control.value | isOptionInSelections:option.value:compareOptions),
                        'is-highlighted': currentFocusedValue === option.value || currentHoveredValue === option.value
                      }"
                      (blur)="onBlur($event)"
                    >
                      <div class="iris-checkmark" (blur)="onBlur($event)">
                        <div class="iris-checkmark-right iris-checkmark-half" (blur)="onBlur($event)"></div>
                        <div class="iris-checkmark-left iris-checkmark-half" (blur)="onBlur($event)"></div>
                      </div>
                    </div>
                  </div>
                  <span
                    class="filter-select-list-item-label"
                    [attr.data-test]="'select-list-item-label-' + option.name"
                  >
                    {{ option.name }}
                  </span>
                </li>
              </ng-container>
            </ul>
          </ng-container>

          <div *ngIf="!showAll && hasTrimmedListCategory">
            <button
              class="show-more-button"
              data-test="show-more-multicolumn-modal"
              aria-label="show-more-options"
              [tabindex]="0"
              (keydown)="handleShowMoreButtonKeyDown($event)"
              (blur)="onBlur($event)"
              (mousedown)="$event.preventDefault()"
              (click)="showAllOptions()"
            >
              Show more
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #singleColumnMultiSelect>
    <div class="filter-select-container">
      <button
        class="filter-select filter-select--multi"
        [ngClass]="[
          control.value?.length ? 'multiple-selections' : '',
          (control.touched | isControlInvalidAndTouched:control.invalid) ? 'invalid' : '',
          formControlClassName
        ]"
        [ngClass]="formControlClassName"
        (mousedown)="expandClickMultiSelectMenu($event)"
        (keydown)="handleMultiSelectKeyDown($event)"
        (keyup.escape)="escapeMenu($event)"
        (blur)="onBlur($event)"
        [attr.aria-describedby]="formControlName
          && (control.touched | isControlInvalidAndTouched:control.invalid)
            ? formControlName + '-error-messages' : null"
        [attr.aria-expanded]="isExpanded"
        [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
        [attr.required]="(control | isControlRequired) || null"
        [attr.aria-label]="placeholder + ': ' + control.value.length + ' selections'"
        aria-haspopup="listbox"
        [disabled]="control.disabled"
        tabindex="0"
        #select
      >
        <div class="filter-select-inner-container">
          <span
            *ngIf="placeholder && currentSelections.length !== 1"
            class="placeholder-text"
          >
            {{ placeholder }}
          </span>
          <span class="highlighted-single-option" *ngIf="currentSelections.length === 1">
            {{ currentSelections[0].name }}
          </span>
          <span
            *ngIf="currentSelections.length > 1"
            class="filter-select-overflow-count"
            data-test="filter-select-count"
          >
            {{ currentSelections.length }}
          </span>
          <iris-icon
            *ngIf="!currentSelections.length"
            name="expand_more"
            class="filter-select-toggle"
            [size]="iconSizes.MD"
            [usage]="iconUsageTypes.DECORATIVE"
            [color]="iconColors.BRAND1"
          ></iris-icon>
          <iris-icon
            *ngIf="currentSelections.length && !isRequired"
            (mousedown)="expandClickMultiSelectMenu($event)"
            class="clear-value-icon filter-select-toggle"
            name="close"
            [size]="iconSizes.SM"
            [usage]="iconUsageTypes.DECORATIVE"
            [attr.data-test]="'clear-value-' + placeholder"
          ></iris-icon>
        </div>
      </button>

      <div
        [ngClass]="{'hidden': !isExpanded, 'drop-up': shouldDropUp}"
        class="filter-select-listbox-wrapper"
      >
        <h3 class="listbox-header">
          {{ placeholder }}
        </h3>
        <div
          class="filter-select-listbox"
          [attr.aria-multiselectable]="true"
          role="listbox"
          #listbox
          [attr.data-test]="'filter-select-listbox-' + placeholder"
        >
          <ng-container *ngFor="let category of categorizedOptions; let categoryIndex = index">
            <h4 *ngIf="category.name && categorizedOptions.length > 1" class="category-label">
              {{ category.name }}
            </h4>
            <ul *ngIf="category.options.length > 0">
              <ng-container *ngFor="let option of category.options; let i = index">
                <li
                  *ngIf="showAll || !category.trimmedListCount || i < category.trimmedListCount"
                  class="filter-select-list-item"
                  [attr.data-test]="'filter-select-list-item-' + option.name"
                  [ngClass]="{'selected': option.value && (control.value | isOptionSelected:option.value)}"
                  [id]="formControlName + '-dropdown-option' + i"
                  (mousedown)="$event.preventDefault()"
                  (click)="changeMultiSelection(option)"
                  (keydown)="handleMultiSelectKeyDown($event)"
                  (keyup.escape)="escapeMenu($event)"
                  (blur)="onBlur($event)"
                  (mouseenter)="onHoverEnter(option.value)"
                  (mouseleave)="onHoverLeave()"
                  [attr.aria-selected]="(control.value | isOptionSelected:option.value)"
                  [attr.aria-label]="option.name"
                  role="option"
                  tabindex="-1"
                >
                  <div class="iris-checkbox" (blur)="onBlur($event)">
                    <div
                      class="iris-checkbox-highlight-circle"
                      [ngClass]="{'show-highlight': currentFocusedValue === option.value || currentHoveredValue === option.value}"
                    ></div>
                    <div
                      class="iris-checkbox-box"
                      [ngClass]="{
                        'is-checked': option.value && (control.value | isOptionSelected:option.value),
                        'is-highlighted': currentFocusedValue === option.value || currentHoveredValue === option.value
                      }"
                      (blur)="onBlur($event)"
                    >
                      <div class="iris-checkmark" (blur)="onBlur($event)">
                        <div class="iris-checkmark-right iris-checkmark-half" (blur)="onBlur($event)"></div>
                        <div class="iris-checkmark-left iris-checkmark-half" (blur)="onBlur($event)"></div>
                      </div>
                    </div>
                  </div>
                  <span class="filter-select-list-item-label">{{ option.name }}</span>
                </li>
              </ng-container>
            </ul>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #single>
  <div class="filter-select-container" >
    <button
      [id]="formControlName + '-select'"
      class="filter-select"
      [ngClass]="[
        control.value?.length ? 'multiple-selections' : '',
        (control.touched | isControlInvalidAndTouched:control.invalid) ? 'invalid' : '',
        formControlClassName
      ]"
      [ngClass]="formControlClassName"
      (mousedown)="expandClickMenu($event)"
      (keydown)="handleKeyDown($event)"
      (keyup.escape)="escapeMenu($event)"
      (blur)="onBlur($event)"
      [attr.aria-describedby]="formControlName
        && (control.touched | isControlInvalidAndTouched:control.invalid)
          ? formControlName + '-error-messages' : null"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
      [attr.required]="(control | isControlRequired) || null"
      [attr.aria-label]="placeholder + (currentSelection ? ' ' + currentSelection.name : '')"
      aria-haspopup="listbox"
      [disabled]="control.disabled"
      tabindex="0"
      #select
    >
      <span class="highlighted-single-option">
        {{ currentSelection?.name || placeholder }}
      </span>
      <iris-icon
        *ngIf="!control.value || isRequired"
        name="expand_more"
        class="filter-select-toggle"
        [size]="iconSizes.MD"
        [usage]="iconUsageTypes.DECORATIVE"
        [color]="iconColors.BRAND1"
      ></iris-icon>
      <iris-icon
        *ngIf="control.value && !isRequired"
        class="clear-value-icon filter-select-toggle"
        (mousedown)="expandClickMenu($event)"
        name="close"
        [size]="iconSizes.SM"
        [usage]="iconUsageTypes.DECORATIVE"
        [attr.data-test]="'clear-value-' + placeholder"
      ></iris-icon>
    </button>

    <div
      [ngClass]="{'hidden': !isExpanded, 'drop-up': shouldDropUp}"
      class="filter-select-listbox-wrapper"
      [attr.data-test]="'filter-' + formControlName"
    >
      <h3 class="listbox-header">
        {{ placeholder }}
      </h3>
      <div
        class="filter-select-listbox"
        role="listbox"
        #listbox
        [attr.data-test]="'filter-select-listbox-' + placeholder"
      >
        <ng-container *ngFor="let category of categorizedOptions; let categoryIndex = index">
          <ul *ngIf="category.options.length > 0">
            <h4 *ngIf="category.name && categorizedOptions.length > 1" class="category-label">
              {{ category.name }}
            </h4>
            <li
              *ngFor="let option of category.options; let i = index"
              class="filter-select-list-item"
              data-test="select-list-item"
              [attr.data-test]="'filter-select-list-item-' + option.name"
              [ngClass]="{'selected': option.value && control.value == option.value}"
              [id]="formControlName + '-select-option' + i"
              (mousedown)="$event.preventDefault()"
              (click)="changeSelection(option)"
              (keydown)="handleKeyDown($event)"
              (keyup.escape)="escapeMenu($event)"
              (blur)="onBlur($event)"
              [attr.aria-selected]="control.value == option.value"
              [attr.aria-label]="(category.name ? category.name + ': ' : '') + option.name"
              role="option"
              tabindex="-1"
            >
              <span
                class="filter-select-list-item-label"
                [attr.data-test]="'select-list-item-label-' + option.name"
              >
                {{ option.name }}
              </span>
            </li>
            <div *ngIf="categoryIndex !== categorizedOptions.length - 1" class="bottom-border"> </div>
          </ul>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
